<div [class]="containerClasses">
  <nz-input-group
    [nzSuffix]="
      type === 'password'
        ? passwordSuffix
        : icon && icon.trim() !== ''
          ? iconTemplate
          : undefined
    "
    [ngClass]="{ 'error-input-group': hasError }"
  >
    <input
      nz-input
      [value]="isPhoneInput ? displayValue : value"
      (input)="onValueChange($any($event.target).value)"
      [placeholder]="isPhoneInput ? '7XX XXX XXX' : placeholder"
      [type]="inputType"
      [disabled]="disabled"
      [ngClass]="{ 'error-input': hasError }"
      class="input-height text-xs 2xl:text-sm"
    />
  </nz-input-group>

  @if (prefixLabel) {
    <ng-template #prefix>
      <div class="flex items-center gap-2 px-2 py-[0.45rem]">
        <span class="text-sm font-bold md:text-xs 2xl:text-sm">{{
          prefixLabel
        }}</span>
        <div *ngIf="showPhonePrefix" class="flex items-center gap-1">
          <span>🇷🇼</span>
          <span class="text-mbaza-gray">+250</span>
        </div>
      </div>
    </ng-template>
  }

  <ng-template #iconTemplate>
    <img [src]="icon" alt="icon" class="h-4 w-4" />
  </ng-template>

  <ng-template #passwordSuffix>
    <nz-icon
      class="ant-input-password-icon"
      [nzType]="showPassword ? 'eye-invisible' : 'eye'"
      (click)="togglePasswordVisibility()"
    />
  </ng-template>

  <!-- Error message displayed above the input -->
  <div class="error-message" *transloco="let t">
    <span *ngIf="hasError && errorMessage">{{ t(errorMessage) }}</span>
  </div>
</div>
